export const GET_HISTORICS_REPORT_CSV = 'GET_HISTORICS_REPORT_CSV';
export const GET_HISTORICS_REPORT_XLSX = 'GET_HISTORICS_REPORT_XLSX';
export const GET_HISTORICS_REPORT_PDF = 'GET_HISTORICS_REPORT_PDF';
export const GET_HISTORICS_REPORT_PAGINATED = 'GET_HISTORICS_REPORT_PAGINATED';
export const SET_HISTORICS_REPORT_PAGINATION = 'SET_HISTORICS_REPORT_PAGINATION';
export const SET_HISTORICS_REPORT_FILTERS = 'SET_HISTORICS_REPORT_FILTERS';
export const RESET_HISTORICS_REPORT = 'RESET_HISTORICS_REPORT';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/constants/historics_report_constants.js